/** Colunas do order by da pesquisa dos representantes */
export enum RepresentanteSearchOrderBy {
    CodigoIntegracaoErp = 1,
    CnpjCpf = 2,
    Nome = 3,
    NomeFantasia = 4,
    Situacao = 5,
    QuantidadeProspects = 6,
    QuantidadeClientesNovos = 7,
    QuantidadeClientesPositivos = 8,
    QuantidadeClientesAtivos = 9,
    QuantidadeClientesPreInativos = 10,
    QuantidadeClientesInativos = 11,
    QuantidadeClientesCongelados = 12,
    QuantidadeClientesBloqueados = 13,
    QuantidadeClientes = 14,
    ModalidadeComercial = 15
};
